import { BrowserRouter, Route, Routes } from "react-router-dom";

import React from "react";
import Login from "../pages/login";
import Dashboard from "../pages/dashboard";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/auth";
import MyLoading from "../components/myLoading";
import Cursos from "../pages/cursos";
import Curso from "../pages/cursos/curso";
import Videos from "../pages/cursos/videos";
import Video from "../pages/cursos/video";
import VideoVisto from "../pages/cursos/videoVisto";
import CursoPermissao from "../pages/cursos/cursoPermissao";
import Colaboradores from "../pages/colaboradores";
import DetalhesCursosColaborador from "../pages/colaboradores/detalhesCursosColaborador";
import TemplateTarefas from "../pages/templateTarefas";
import localTarefa from "../pages/localTarefa";
import TemplateFormulario from "../pages/templateTarefas/templateFormulario";
import LocalTarefaFormulario from "../pages/localTarefa/localTarefaFormulario";
import Tarefas from "../pages/tarefas";
import TarefasFormulario from "../pages/tarefas/tarefasFormulario";
import ChecklistVeiculos from "../pages/checklistVeiculos";
import Relatorios from "../pages/relatorios";
import Permissoes from "../pages/permissoes";
import Acompanhamento from "../pages/acompanhamento";
import PermissaoTemplate from "../pages/templateTarefas/permissaoTemplate";
import UsuariosClientes from "../pages/usuariosClientes";
import UsuarioClienteFormulario from "../pages/usuariosClientes/formulario";
import DashboardTarefas from "../pages/dashboardTarefas";


const EstaLogadoAdmin = ({Item}) => {
    const { user, signIn } = useContext(AuthContext)
    const [loading, setLoading] = useState(!user.value)

    useEffect(()=>{
        
        const secao = localStorage.getItem("paloGestor@data") && JSON.parse(localStorage.getItem("paloGestor@data"))
        if (secao && secao.user !== '' && secao.token !== '' && !user.value){
            signIn(secao)
        }
        setLoading(false)

    }, [])

    return (
        loading ? <MyLoading render={true} /> : user.value && user.is_staff ? <Item /> : <Login />
    )
}

const EstaLogado = ({Item}) => {
    const { user, signIn } = useContext(AuthContext)
    const [loading, setLoading] = useState(!user.value)

    useEffect(()=>{
        
        const secao = localStorage.getItem("paloGestor@data") && JSON.parse(localStorage.getItem("paloGestor@data"))
        if (secao && secao.user !== '' && secao.token !== '' && !user.value){
            signIn(secao)
        }
        setLoading(false)

    }, [])

    return (
        loading ? <MyLoading render={true} /> : user.value ? <Item /> : <Login />
    )
}

const RoutesApp = () =>{
    
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/gestor/dashboard" element={<EstaLogado Item={Dashboard} />} />
                <Route path="/gestor/cursos" element={<EstaLogado Item={Cursos} />} />                
                <Route path="/gestor/curso/:id" element={<EstaLogado Item={Curso} />} /> 
                <Route path="/gestor/curso" element={<EstaLogado Item={Curso} />} />                
                <Route path="/gestor/curso/:idCurso/videos" element={<EstaLogado Item={Videos} />} />                 
                <Route path="/gestor/curso/:idCurso/video" element={<EstaLogado Item={Video} />} />                 
                <Route path="/gestor/curso/:idCurso/video/:id" element={<EstaLogado Item={Video} />} />                                 
                <Route path="/gestor/curso/:idCurso/videovisto/:id" element={<EstaLogado Item={VideoVisto} />} />                                                 
                <Route path="/gestor/curso/:idCurso/permissao" element={<EstaLogado Item={CursoPermissao} />} />                                 
                <Route path="/gestor/colaboradores" element={<EstaLogado Item={Colaboradores} />} />                
                <Route path="/gestor/colaboradores/:id" element={<EstaLogado Item={DetalhesCursosColaborador} />} />

                <Route path="/gestor/localtarefa" element={<EstaLogado Item={localTarefa} />} />                                                                                
                <Route path="/gestor/localtarefa/formulario/:id" element={<EstaLogado Item={LocalTarefaFormulario} />} />                                                                                
                <Route path="/gestor/localtarefa/formulario"  element={<EstaLogado Item={LocalTarefaFormulario} />} />                                                                                
                
                <Route path="/gestor/template" element={<EstaLogado Item={TemplateTarefas} />} />                                                                
                <Route path="/gestor/template/formulario/:id" element={<EstaLogado Item={TemplateFormulario} />} />                 
                <Route path="/gestor/template/formulario" element={<EstaLogado Item={TemplateFormulario} />} />       
                <Route path="/gestor/template/:idTemplate/permissao" element={<EstaLogado Item={PermissaoTemplate} />} />                                                                           

                <Route path="/gestor/tarefas" element={<EstaLogado Item={Tarefas} />} />
                {/* Dashboard gerencial protegido pela autenticação e pela permissão interna de Tarefas. */}
                <Route path="/gestor/dashboard-tarefas" element={<EstaLogado Item={DashboardTarefas} />} />
                <Route path="/gestor/checklist-veiculos" element={<EstaLogado Item={ChecklistVeiculos} />} />                                            
                <Route path="/gestor/tarefas/formulario/:id" element={<EstaLogado Item={TarefasFormulario} />} />                                                     

                <Route path="/gestor/relatorios" element={<EstaLogado Item={Relatorios} />} />                                                            
                <Route path="/gestor/permissoes" element={<EstaLogado Item={Permissoes} />} />
                <Route path="/gestor/usuarios-clientes" element={<EstaLogado Item={UsuariosClientes} />} />
                <Route path="/gestor/usuarios-clientes/cadastro" element={<EstaLogado Item={UsuarioClienteFormulario} />} />
                <Route path="/gestor/usuarios-clientes/:id" element={<EstaLogado Item={UsuarioClienteFormulario} />} />
                <Route path="/gestor/acompanhamento" element={<EstaLogado Item={Acompanhamento} />} />                     

                <Route path="/gestor" element={<Login />} />

                
                <Route path="/atendimento" element={<Login />} />
                <Route path="*" element={<Login />} />
            </Routes>
        </BrowserRouter>
    )
}

export default RoutesApp;
